import sv from "./sv.json";

const resources = {
	sv
};

export default resources;
